import { createGetConfig } from './configRuntime';

export const appMode = import.meta.env.MODE;

export const getConfig = createGetConfig({
  getMode: () => appMode,
  loaders: {
    loadDev: async () => {
      const { default: config } = await import('../../config.dev.json');
      return config;
    },
    loadStage: async () => {
      const { default: config } = await import('../../config.stage.json');
      return config;
    },
    loadProd: async () => {
      const { default: config } = await import('../../config.prod.json');
      return config;
    },
  },
  logError: (message, error) => {
    console.error(message, error);
  },
});
